<div class="row">
    <div class="col-sm-4">
        <h4 class="text-center">Arriving Today</h4>
        <div class="list-gr oup">
            <button *ngFor="let dog of onCal" (click)="showOptionButtons(dog.ID)" type="button"
                class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{dog.NAME}}</h5>
                    <p class="mb-1">{{dog.TIME}}</p>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <p class="mb-1">{{dog.PHONE}}</p>
                    <p class="mb-1">{{dog.SERVICE}}</p>
                </div>
                <div *ngIf="showOptions == dog.ID" class="d-flex w-100 justify-content-between mt-2">
                    <button class="mb-1 btn btn-danger">Remove</button>
                    <button class="mb-1 btn btn-secondary">Edit</button>
                    <button class="mb-1 btn btn-primary">Check In</button>
                </div>
            </button>
        </div>
    </div>
    <div class="col-sm-4">
        <h4 class="text-center">Currently In Progress</h4>
        <div class="list-group">
            <button *ngFor="let dog of inProgress" (click)="showOptionButtons(dog.ID)" type="button"
                class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{dog.NAME}}</h5>
                    <p class="mb-1">Arrived at {{dog.TIME}}</p>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <p class="mb-1">{{dog.PHONE}}</p>
                    <p class="mb-1">{{dog.SERVICE}}</p>
                </div>
                <div *ngIf="showOptions == dog.ID" class="d-flex w-100 justify-content-between mt-2">
                    <button class="mb-1 btn btn-danger">Remove</button>
                    <button class="mb-1 btn btn-secondary">Edit</button>
                    <button class="mb-1 btn btn-primary">Check Out</button>
                </div>
            </button>
        </div>
    </div>
    <div class="col-sm-4">
        <h4 class="text-center">Sent Home</h4>
        <div class="list-group">
            <button *ngFor="let dog of sentHome" (click)="showOptionButtons(dog.ID)" type="button"
                class="list-group-item list-group-item-action">
                <div class="d-flex w-100 justify-content-between">
                    <h5 class="mb-1">{{dog.NAME}}</h5>
                    <p class="mb-1">Sent home at {{dog.TIME}}</p>
                </div>
                <div class="d-flex w-100 justify-content-between">
                    <p class="mb-1">{{dog.PHONE}}</p>
                    <p class="mb-1">{{dog.SERVICE}}</p>
                </div>
            </button>
        </div>
    </div>
</div>